import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { SiteManagementComponent } from './site-management.component';
import { SharedLayoutModule } from '../shared-layout/shared-layout.module';
import { SiteDetailsComponent } from './site-details/site-details.component';
import { AddBuildingComponent } from '../building-managment/add-building/add-building.component';
import { ActivityComponent } from './activity/activity.component';
import { EditSiteComponent } from './edit-site/edit-site.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpClientModule } from '@angular/common/http';
import { BuildingManagementModule } from '../building-managment/building-management.module';
import {
  MatDialogModule,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { SitesViewModule } from './sites-view/sites-view.module';
import { ListItemsComponent } from './list-items/list-items.component';
import { SiteManagerComponent } from './site-manager/site-manager.component';
import { SiteSettingsComponent } from './site-settings/site-settings.component';
import { MasterCredentialComponent } from './master-credential/master-credential.component';
import { FloorManagementModule } from '../floor-management/floor-management.module';
import { BuildingManagementComponent } from '../building-managment/building-management.component';
import { AccessControlModule } from '../libs/ui/directives/access-control/access-control.module';
import { ControlDisabledDirectiveModule } from '../libs/ui/directives/control-disabled/control-disabled-directive.module';
import { MatSelectModule } from '@angular/material/select';
import {
  MatAutocompleteModule,
  MAT_AUTOCOMPLETE_SCROLL_STRATEGY,
} from '@angular/material/autocomplete';
import { CloseScrollStrategy } from '@angular/cdk/overlay/scroll/close-scroll-strategy';
import { Overlay } from '@angular/cdk/overlay';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { SortByModule } from 'src/app/libs/ui/pipes/sort-by/sort-by.module';
import { ParsedActivityDateTimePipe } from '../libs/ui/pipes/parsed-activity-date-time/parsed-activity-date-time.pipe';
import { UniqueChangeDetectorCharacterPipe } from '../libs/ui/pipes/unique-change-detector-character/unique-change-detector-character.pipe';
import { WithTooltipModule } from '../shared-layout/Components/with-tooltip/with-tooltip.module';
import { LocalizationService } from '../shared/services/localization.service';
import { TranslateModule } from '@ngx-translate/core';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { ParsedActivityDateTimeModule } from '../libs/ui/pipes/parsed-activity-date-time/parsed-activity-date-time.pipe.module';
import { ParsedDateTimeModule } from '../libs/ui/pipes/parsed-date-time/parsed-date-time.module';
import { EditMasterCredentialDescriptionComponent } from './edit-master-credential-description/edit-master-credential-description.component';
import { MasterCredentialDetailComponent } from './master-credential-detail/master-credential-detail.component';
const routes: Routes = [
  {
    path: '',
    component: SiteManagementComponent,
  },
];

export function scrollFactory(overlay: Overlay): () => CloseScrollStrategy {
  return () => overlay.scrollStrategies.close();
}

@NgModule({
  declarations: [
    SiteManagementComponent,
    AddBuildingComponent,
    SiteDetailsComponent,
    AddBuildingComponent,
    ActivityComponent,
    EditSiteComponent,
    ListItemsComponent,
    SiteManagerComponent,
    BuildingManagementComponent,
    EditMasterCredentialDescriptionComponent,
    MasterCredentialDetailComponent,
    SiteSettingsComponent,
    MasterCredentialComponent,
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    SharedLayoutModule,
    WithTooltipModule,
    BuildingManagementModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatCardModule,
    NgbModule,
    HttpClientModule,
    MatDialogModule,
    SitesViewModule,
    FloorManagementModule,
    ControlDisabledDirectiveModule,
    AccessControlModule,
    MatSelectModule,
    MatAutocompleteModule,
    ScrollingModule,
    SortByModule,
    TranslateModule,
    InfiniteScrollModule,
    ParsedActivityDateTimeModule,
    ParsedDateTimeModule,
  ],
  providers: [
    { provide: MatDialogRef, useValue: {} },
    { provide: MAT_DIALOG_DATA, useValue: [] },
    {
      provide: MAT_AUTOCOMPLETE_SCROLL_STRATEGY,
      useFactory: scrollFactory,
      deps: [Overlay],
    },
    ParsedActivityDateTimePipe,
    UniqueChangeDetectorCharacterPipe,
    LocalizationService,
    TranslateModule,
  ],
})
export class SiteManagementModule {}
